import { doc, updateDoc, getDoc } from 'firebase/firestore';
import { db } from '../services/firebase';

/**
 * Met à jour les stats de réservation d'un client
 * @param {string} clientId - ID du client
 * @param {string} reservationNumber - Numéro de la réservation
 * @param {string} status - 'pending', 'confirmed', ou 'cancelled'
 */
export const updateClientReservationStats = async (clientId, reservationNumber, status) => {
  if (!clientId || !reservationNumber) {
    console.warn('⚠️ updateClientReservationStats: clientId ou reservationNumber manquant');
    return;
  }

  try {
    const clientRef = doc(db, 'clients', clientId);
    const clientSnap = await getDoc(clientRef);

    if (!clientSnap.exists()) {
      console.warn(`⚠️ Client ${clientId} introuvable`);
      return;
    }

    const clientData = clientSnap.data();
    const reservationsStats = clientData.reservationsStats || {};

    // Mettre à jour le statut de cette réservation
    reservationsStats[reservationNumber] = { status };

    await updateDoc(clientRef, {
      reservationsStats,
      updatedAt: new Date()
    });

    console.log(`✅ Stats client ${clientId} mises à jour : ${reservationNumber} → ${status}`);
  } catch (error) {
    console.error('❌ Erreur updateClientReservationStats:', error);
  }
};